import { AlertTriangle, CalendarClock, FileText, ReceiptText } from "lucide-react";
import type { Proforma } from "@/lib/proforma.api";
import { formatMoney, formatProformaAge } from "../proforma-formatters";
import type { ProformaMetrics } from "../proforma-calculations";
import { ProformaKpiCard } from "./ProformaKpiCard";

interface ProformaStatsGridProps {
  proformasCount: number;
  metrics: ProformaMetrics;
  latest?: Proforma;
  loading: boolean;
}

export function ProformaStatsGrid({
  proformasCount,
  metrics,
  latest,
  loading,
}: ProformaStatsGridProps) {
  const watchCount = metrics.expiredCount + metrics.cancelledCount;

  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <ProformaKpiCard
        label="Proformas"
        value={loading ? "..." : String(proformasCount)}
        detail={`${metrics.activeCount} active${metrics.activeCount > 1 ? "s" : ""}`}
        icon={FileText}
        tone="gold"
      />
      <ProformaKpiCard
        label="Valeur totale"
        value={loading ? "..." : formatMoney(metrics.totalValue)}
        detail="Toutes proformas listées"
        icon={ReceiptText}
        tone="success"
      />
      <ProformaKpiCard
        label="À surveiller"
        value={loading ? "..." : String(watchCount)}
        detail={`${metrics.expiredCount} expirée${metrics.expiredCount > 1 ? "s" : ""} · ${metrics.cancelledCount} annulée${metrics.cancelledCount > 1 ? "s" : ""}`}
        icon={AlertTriangle}
        tone={watchCount > 0 ? "danger" : "neutral"}
      />
      <ProformaKpiCard
        label="Dernière proforma"
        value={latest?.number ?? "-"}
        detail={
          latest
            ? `${latest.partySnapshot?.fullName ?? "Client"} · ${formatProformaAge(latest.createdAt)}`
            : "Aucune proforma"
        }
        icon={CalendarClock}
        tone="neutral"
      />
    </div>
  );
}
